<template>
  <div class="Item">
    <b-card class="mt-3 shadow" 
      :border-variant="chooseVariant(item.type)"
      no-body
      v-on:click="toggleActive()"
    >

      <b-card-body class="py-1"  
        :body-bg-variant="active ? ((item.type == 'need') ? 'info' : 'warning') : '' "
        :body-text-variant="active ? 'white' : ''"
      >
        <b-card-title class="d-flex flex-row my-0 align-items-end py-1" title-tag="div">
          <h5 class="mb-0 float-left text-left flex-fill">{{ item.item }}</h5>
          <h6 class="mb-0 float-right text-right">Anzahl: {{ item.amount }}</h6>
        </b-card-title>

        <b-card-text class="mt-0">
          <div class="d-flex flex-row align-items-start">
            <div class="mb-0 float-left text-left flex-fill">
              <p class="mb-1">
                <span v-if="item.email && active">{{ item.email }}<br/></span>
                <span v-if="item.tel && active">{{ item.tel }}<br/></span>
              </p>
              <p class="mb-0">              
                <span v-if="item.name && active"><b>{{ item.name }}</b><br/></span>
                <span v-if="item.address && active">{{ item.address }} <br/></span>
                <span v-if="item.zip" v-bind:class="{ 'font-weight-bold': ! active }">{{ item.zip }} </span>
                <span v-if="item.city" v-bind:class="{ 'font-weight-bold': ! active }">{{ item.city }}<br/></span>
                <span v-if="item.country">{{ item.country }}</span>
              </p>
            </div>
          </div>
        </b-card-text>
      </b-card-body>
      <b-card-footer class="my-0 py-1">
        <div class="d-flex flex-row">
          <small class="flex-left text-left flex-fill">
            Created: <timeago :datetime="item.created_at"></timeago>
          </small>
          <small class="flex-right text-right ">
            Last updated: 
              <timeago v-if="item.updated_at" :datetime="item.updated_at"></timeago>
              <timeago v-else :datetime="item.created_at"></timeago>
          </small>
        </div>
        <div class="d-flex text-center" v-if="active">
          <small class="uuid">
            UUID: {{ item.uuid }}
          </small>
        </div>
      </b-card-footer>
    </b-card>  
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: false,
    }
  },
  props: ['item'],
  watch: {
    
  },
  methods: {
    chooseVariant (type) {
      if (type === "need") {
        return "info"
      } else {
        return "warning"
      }
    },
    toggleActive () {
      var selection = window.getSelection();
      if(!selection.toString()) {
        this.active = !this.active
      }
    },
  },
}
</script>

<style>

.Item .card {
  cursor: pointer;
}

.card-text p {
  line-height: 1.3em;
}
small.uuid {
  font-size: 0.6em;
  line-height: 1.1em;
}

</style>